import clsx from 'clsx';
import React, { FC, ReactNode } from 'react';
import { Button, ButtonType } from './Button';
import { Spinner, spinnerStyleEnum } from './Spinner';

interface ButtonWithIconAndLoaderProps {
  title: string;
  onClick: () => void;
  icon?: ReactNode;
  loading?: boolean;
  className?: string;
  disabled?: boolean;
  labelClasses?: string;
  kind?: keyof typeof ButtonType;
}

export const ButtonWithIconAndLoader: FC<ButtonWithIconAndLoaderProps> = ({
  title,
  icon = null,
  onClick,
  loading,
  className,
  labelClasses,
  disabled,
  kind
}) => {
  return (
    <Button
      onClick={onClick}
      kind={kind || (loading ? 'loading' : 'primary')}
      className={clsx(className || 'flex items-center justify-center font-effra btn min-w-136 w-max')}
      disabled={loading || disabled}
    >
      <p className={clsx(labelClasses || 'text-lg')}>{title}</p>
      <div className={clsx(!loading && !icon && 'hidden', icon && 'ml-2')}>
        {loading ? <Spinner size={16} spinnerStyle={spinnerStyleEnum.PRIMARY} /> : icon}
      </div>
    </Button>
  );
};
